export type ConfigValue = {
  group_id: string,
  namespace: string,
  value: string,
  active: boolean,
  expose: boolean,
  key: string,
  created_at: string,
  updated_at: string,
}

export type CssVariablesList = { [key: string]: { [key: string]: ConfigValue } };

export const CSS_TYPES = {
  DEFAULT: 'css-variables-default',
  DARK: 'css-variables-dark',
  MOBILE: 'css-variables-mobile'
}